import { TailSpin } from 'react-loader-spinner'

const Spinner = (props: any) => {
	return <>
		<TailSpin
			color='#7e84f4'
			height={props.height ? props.height : '50'}
			width={props.width ? props.height : '50'}
			wrapperClass='spinner'
		/>
	</>
}

export default Spinner;
